import * as React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import InsertCommentIcon from '@mui/icons-material/InsertComment'
import LastPageIcon from '@mui/icons-material/LastPage'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack } from '@mui/material'
import TableHead from '@mui/material/TableHead'
import '../../../App.css'
import '../../../css/modal.scss'
import { updateDestBrnch, updateDestCity, getListData, updateAlert } from '../../../store/common/common_action'
import { useSearchParams } from 'react-router-dom'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { useEffect } from 'react'
import { getUpdateSHowListData } from '../../../store/branchTransferReceive/branchReceive_action'
import { activeClass, focusElemnt } from '../../common/helper'
import moment from 'moment'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { branchTransferFilteredTableRowsAtom } from '../../common/jotaiState/dispatchStateAtoms'

const MiddleSection = ({
  data,
  inputCheck,
  selelectedData,
  setSelectedData,
}) => {
  const { BranchTransferReceiveReducer } = data
  const { listData } = { ...BranchTransferReceiveReducer }

  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(8)
  const [companySettings] = useAtom(companySettingsAtom)
  const [, setFilteredTableRows] = useAtom(branchTransferFilteredTableRowsAtom)
  const { UseToPayAsCOD = 0 } = companySettings
  const { DefaultCurrencyID } = companySettings

  // All State
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
  })
  const { startIndex, lastIndex, Total, TotalAmount } = state
  const [ListData, setListData] = useState()
  const [TableListData, setTableListData] = useState('')
  const [filtered, setFiltered] = useState([])
  const [searchStatus, setSearchStatus] = useState(false)
  const selectAllRef = React.useRef(null)

  // All useEffects
  useEffect(() => {
    if (listData?.Table?.length >= 1) {
      const updatedTable = [...listData.Table];
      if (UseToPayAsCOD === 1) {
        updatedTable.forEach((item) => {
          if (item.PaymentType === 'TO PAY') item.PaymentType = 'COD';
          else if (item.PaymentType === 'TO PAY Manual') item.PaymentType = 'COD Manual';
          else if (item.PaymentType === 'TO PAY DDDV') item.PaymentType = 'COD(DDDV)';
        });
      }
    } else {
      setListData([]);
    }
  }, [listData, UseToPayAsCOD]);

  useEffect(() => {
    if (!inputCheck) {
      if (listData?.Table?.length >= 1) {
        const arry = listData?.Table?.map((val) => ({ ...val, checked: false }))
        // console.log(678987,arry)
        setTableListData('DataLoaded')
        setListData(arry)
        setTimeout(() => {
          document.getElementById('checkbox_0').focus()
        }, 0)
      } else {
        setListData([])
        setTableListData('Empty')
      }
    }
  }, [listData, inputCheck])
  //   useEffect(() => {
  //     console.log(topSelectedData,tSecDropData)
  //     if (loginData) {
  //  if(topSelectedData.SelectedVehicle==null){
  //     handleAlert("Select Vehicle")
  //  } else {
  // const dtDate=topSelectedData.SelectedVehicle.VehicleWithDetail.split(":")
  //    const object = {
  //        intFromBranchID: topSelectedData.DFromBranch.BranchID,
  //       intToBranchID: strtBrnch.BranchID,
  //       strVehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
  //       intVoucherNo: tSecDropData.SellectedChallanNumber=="All"?0:tSecDropData.SellectedChallanNumber.VoucherNo,
  //       intVehicleID: topSelectedData.SelectedVehicle.VehicleID,
  //       dtDate:dtDate[1],
  //       intConsignmentID: tSecDropData.selectconsignmentType==="All"?0:tSecDropData.selectconsignmentType.ConsignmentSubTypeID
  //    }
  //    getUpdateSHowListData(loginData, object)

  //    setSelectedData([])
  //  }
  //     }
  //   }, [loginData])


  useEffect(() => {
    if (inputCheck == true) {
      if (selelectedData?.length === 0 || selelectedData === undefined) {
        const arry = listData?.Table?.map((val) => ({ ...val, checked: true }))
        setListData(arry)
        setSelectedData(listData?.Table)
      } else {
        const selBookId = selelectedData.map(({ BookingID }) => BookingID)
        let filterLR = listData?.Table?.filter((item) => selBookId.includes(item.BookingID))
        const arry = listData?.Table?.map((val) => ({ ...val, checked: selBookId.includes(val.BookingID) ? true : false }))
        setListData(arry)
        setSelectedData(filterLR)
      }
    }
    if (listData?.Table?.length > 0) {
      setTableListData('DataLoaded')
    } else {
      setSelectedData([])
    }
  }, [listData, inputCheck])
  useEffect(() => {
    const citrus = listData?.Table?.slice(startIndex, lastIndex)
    const total = citrus?.map((item) => item?.Quantity).reduce((partialSum, a) => partialSum + a, 0)
    const totalAmt = citrus?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    setState({ ...state, Total: total, TotalAmount: totalAmt?.toFixed(2) })
  }, [startIndex, lastIndex, listData])

  const onChange = (e, i, BookingIDItem) => {
    const { checked } = e.target
    if (checked) {
      // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(id) ? (val.checked = true) : ''))
      ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
      filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
      const data = (searchStatus ? filtered : ListData)?.filter((val) => val.BookingID == Number(BookingIDItem))
      const selectedObject = [...selelectedData, data[0]]
      setSelectedData(selectedObject)
    } else {
      // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      const data = selelectedData.filter((item) => item.BookingID !== Number(BookingIDItem))
      setSelectedData(data)
    }
    setTimeout(() => {
      focusElemnt(`checkbox_${i}`);
    }, 3)
  }
  const addRemoveKeydown = (e, i) => {
    if (e.key === 'ArrowDown') {
      focusElemnt(`checkbox_${i + 1}`);
    }
    if (e.key === 'ArrowUp') {
      focusElemnt(`checkbox_${i - 1}`);
    }
    if (e.key === 'Enter') {
      focusElemnt('remarksBranchReceive');
    }
    if (e.key === 'Escape') {
      focusElemnt("showListBranchReceive");
    }
  }
  const InsideRowContent = ({ item, index }) => {
    const [show, setShow] = useState(false)
    //this function for  total
    const handleCalculation = (list, name) => {
      let total = 0
      for (let i in list) {
        total = total + Number(list[i][name])
      }
      return total.toLocaleString('en-IN')
    }

    const handleTotalCalculation = (list) => {
      let frieght = list.ConsignmentData.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
      let total = frieght + list.AllCartage + list.AllHamali + list.Other + list.Valuation + list.GST
      return total.toLocaleString('en-IN')
    }

    return (
      <>
        <TableRow key={index}>
          <TableCell className="checkbox-ctrl">

            <input
              type="checkbox"
              id={`checkbox_${index}`}
              // value={item}
              onChange={(e) => onChange(e, index, item.BookingID)}
              checked={item.checked}
              onKeyDown={(e) => addRemoveKeydown(e, index)}
            // name="record"
            />
          </TableCell>
          <TableCell>
            {item.LRNO}
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
              {item.ManualLRNo}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.BookingDate}>
              {moment(item.BookingDate).format('DD MMM YYYY  LT')}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.DescriptionDet}>
              {/* hii */}

              {item?.ConsignmentData?.length === 1 ? item.DescriptionDet : 'Multi'}
            </span>
          </TableCell>
          <TableCell>
            <span className={activeClass(item.PaymentType)} title={item.PaymentType}>
              {item.PaymentType}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '13px', paddingRight: '30px' }} title={item.Quantity}>
              {item.Quantity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.Sender}>
              {item.Sender}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.RecName}>
              {item.RecName}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.FromCity}>
              {item.FromCity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.ToCity}>
              {item.ToCity}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '13px', paddingRight: '29px' }} title={item.NetAmount}>
              {/* {item.NetAmount} */}
              {Number(item.NetAmount).toLocaleString('en-IN')}
            </span>
          </TableCell>
          <TableCell className="iconCell" style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'end' }}>
            {item.Comments === '' ? (
              // <span title={item.Comments}>
              //   <InsertCommentIcon id="iconBox" className="icon2" style={{ color: 'gray' }} />
              // </span>
              ''
            ) : (
              <span title={item.Comments}>
                <InsertCommentIcon id="iconBox" className="icon2" style={{ marginRight: '13px' }} />
              </span>
            )}
            <span
              onClick={() => {
                setShow(!show)
              }}
            >
              {show ? <RemoveCircleIcon id="iconBox" className="icon2 " /> : <AddCircleIcon id="iconBox" className="icon2 " />}
            </span>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={14} style={{ padding: '0' }}>
            <div
              className="tabelAccordionWrapper"
              style={{
                maxHeight: '110px',
                overflowY: 'scroll',
              }}
            >
              <Table className="table1 table-branch sub-table" size="small" aria-label="a dense table">
                <TableBody className="filter-data-row">
                  {show && (
                    <>
                      <TableRow key={index} style={{ background: '#E5D6CF' }}>
                        <TableCell className="checkbox-ctrl" style={{ background: '#E5D6CF' }}></TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }} title={'ConsignmentSubType'}>
                            Consign Type
                          </span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Description</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Unit</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Goods Value</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Weight</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Rate</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Frieght</span>
                        </TableCell>

                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Cartage</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Hamali</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Other</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{DefaultCurrencyID === 2 ? 'Insurance' : 'Valuation'}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>GST</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Total</span>
                        </TableCell>
                      </TableRow>

                      {item.ConsignmentData.map((val, i) => {
                        return (
                          <>
                            <TableRow key={i} style={{ background: '#FBEDE7' }}>
                              <TableCell className="checkbox-ctrl" style={{ background: '#FBEDE7' }}></TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.ConsignmentSubType}>
                                  {val.ConsignmentSubType}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.Description}>
                                  {val.Description}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Quantity}>
                                  {val.Quantity}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.GoodsValue}>
                                  {val.GoodsValue}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.ActualWeight}>
                                  {val.ActualWeight}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Rate}>
                                  {val.Rate}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Freight}>
                                  {/* {val.Freight} */}
                                  {Number(val.Freight).toLocaleString('en-IN')}
                                </span>
                              </TableCell>

                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllCartage}>
                                  {/* {item.AllCartage} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllCartage}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllHamali}>
                                  {/* {item.AllHamali} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllHamali}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Other}>
                                  {item.ConsignmentData.length > 1 ? 0 : item.Other}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {/* {item.Valuation} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.Valuation}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={Number(item.GST).toLocaleString('en-IN')}>
                                  {/* {Number(item.GST).toLocaleString("en-IN")} */}
                                  {item.ConsignmentData.length > 1 ? 0 : Number(item.GST).toLocaleString('en-IN')}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {/* {item.Valuation} */}
                                  {item.ConsignmentData.length > 1 ? 0 : handleTotalCalculation(item)}
                                </span>
                              </TableCell>
                              {/* <TableCell></TableCell> */}
                            </TableRow>
                          </>
                        )
                      })}
                      {item.ConsignmentData.length > 1 ? (
                        <TableRow style={{ background: '#e9d5cf' }}>
                          <TableCell className="checkbox-ctrl" style={{ background: '#e9d5cf' }}></TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Grand Total</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}></span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Quantity')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'GoodsValue')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'ActualWeight')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{handleCalculation(item.ConsignmentData, 'Rate')}</span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Freight')}
                            </span>
                          </TableCell>

                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllCartage}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllHamali}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Other}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Valuation}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>
                              {/* {Number(item.GST).toLocaleString('en-IN')} */}123
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {/* {Number(item.GST).toLocaleString("en-IN")} */}
                              {handleTotalCalculation(item)}
                            </span>
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                        </TableRow>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </div>
          </TableCell>
        </TableRow>
      </>
    )
  }

  //All Functionality of pagination  start
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  function TablePaginationActions(props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
      setState({ ...state, startIndex: 0, lastIndex: 8 })
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
      setState({ ...state, startIndex: startIndex - 8, lastIndex: startIndex })
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
      if (listData?.Table?.length >= lastIndex + 8) {
        setState({ ...state, startIndex: lastIndex, lastIndex: lastIndex + 8 })
      } else {
        setState({ ...state, startIndex: lastIndex, lastIndex: listData?.Table?.length + 1 })
      }
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      const div = listData?.Table?.length % 8
      if (div == 0) {
        const index = listData?.Table?.length - 8
        setState({ ...state, startIndex: index, lastIndex: listData?.Table?.length + 1 })
      } else {
        const index = listData?.Table?.length - (listData?.Table?.length % 8)
        setState({ ...state, startIndex: index, lastIndex: listData?.Table?.length + 1 })
      }
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          style={{ padding: '0px', margin: '0px' }}
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }
  //All Functionality of pagination end

  let repeatdata = [
    { id: 0, name: 'contains', colName: 'LRNO' },
    { id: 1, name: 'contains', colName: 'ManualLRNo' },
    { id: 2, name: 'contains', colName: 'BookingDateTime' },
    { id: 3, name: 'contains', colName: 'DescriptionDet' },
    { id: 4, name: 'contains', colName: 'PaymentType' },
    { id: 5, name: 'contains', colName: 'Quantity' },
    { id: 6, name: 'contains', colName: 'Sender' },
    { id: 7, name: 'contains', colName: 'RecName' },
    { id: 8, name: 'contains', colName: 'FromCity' },
    { id: 9, name: 'contains', colName: 'ToCity' },
    { id: 10, name: 'contains', colName: 'NetAmount' },
  ]
  const handleChangeContain = (id, name) => {
    var userInput = document.getElementsByName('searchInput')[id].value
    var count = 0
    const lData = []
    const data = ListData
    if (userInput !== '') {
      var regex = new RegExp(userInput.trim().replace(/\\/g, "\\\\"), 'i')
      {
        data.map((val) => {
          if ((val[name] != null ? val[name].toString() : '').search(regex) !== -1) {
            const x = {
              ActualWeight: val.ActualWeight,
              AllCartage: val.AllCartage,
              AllHamali: val.AllHamali,
              BookingDate: val.BookingDate,
              BookingID: val.BookingID,
              BranchTransferDetID: val.BranchTransferDetID,
              BranchTransferID: val.BranchTransferID,
              Comments: val.Comments,
              ConsignmentData: val.ConsignmentData,
              DamageQty: val.DamageQty,
              Description: val.Description,
              DescriptionDet: val.DescriptionDet,
              DestinationBranchID: val.DestinationBranchID,
              DestinationBranchName: val.DestinationBranchName,
              DocumentCharges: val.DocumentCharges,
              FormattedLRNo: val.FormattedLRNo,
              Freight: val.Freight,
              FromBranchID: val.FromBranchID,
              FromCity: val.FromCity,
              FromCityID: val.FromCityID,
              GST: val.GST,
              GoodsValue: val.GoodsValue,
              LRNO: val.LRNO,
              MOPName: val.MOPName,
              ManualLRNo: val.ManualLRNo,
              NetAmount: val.NetAmount,
              Other: val.Other,
              PARCEL: val.PARCEL,
              PaymentType: val.PaymentType,
              PerQuantity: val.PerQuantity,
              Quantity: val.Quantity,
              Rate: val.Rate,
              RecAddress: val.RecAddress,
              RecMobileNo: val.RecMobileNo,
              RecName: val.RecName,
              ReceiverEmailID: val.ReceiverEmailID,
              ReceiverGSTN: val.ReceiverGSTN,
              Select: val.Select,
              Sender: val.Sender,
              SenderAddress: val.SenderAddress,
              SenderEmailID: val.SenderEmailID,
              SenderGSTN: val.SenderGSTN,
              SenderMobileNo: val.SenderMobileNo,
              ShortQty: val.ShortQty,
              SubType: val.SubType,
              ToBranchID: val.ToBranchID,
              ToCity: val.ToCity,
              ToCityID: val.ToCityID,
              Valuation: val.Valuation,
              VehicleNo: val.VehicleNo,
              VoucherNo: val.VoucherNo,
              checked: val.checked,
            }
            lData.push(x)
            count++
          }
        })
      }
      setFiltered(lData)
      // lData.forEach((filterItem) => {
      //   if (filterItem.isChecked) {
      //     const correspondingItem = ListData.find((listItem) => listItem.BookingID === filterItem.BookingID)
      //     if (correspondingItem) {
      //       correspondingItem.checked = true // or whatever value you need
      //     }
      //     setListData(correspondingItem)
      //   }
      // })
      // setSearchStatus(true)
      setSearchStatus(true)
    } else {
      setFiltered([])
      setSearchStatus(false)
    }
  }
  const visibleTableRows = React.useMemo(() => (searchStatus ? filtered : ListData || []), [searchStatus, filtered, ListData])
  const visibleBookingIds = visibleTableRows.map((item) => item.BookingID)
  const availableRowsSelectedCount = visibleTableRows.filter((item) => item.checked).length
  const showSelectAllCheckbox = visibleTableRows.length > 1
  const areAllVisibleSelected = showSelectAllCheckbox && availableRowsSelectedCount === visibleTableRows.length
  const areSomeVisibleSelected = availableRowsSelectedCount > 0 && !areAllVisibleSelected

  useEffect(() => {
    setFilteredTableRows(visibleTableRows)
  }, [visibleTableRows, setFilteredTableRows])

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = areSomeVisibleSelected
    }
  }, [areSomeVisibleSelected])

  useEffect(() => {
    return () => {
      setFilteredTableRows([])
    }
  }, [setFilteredTableRows])

  const handleToggleVisibleRows = (e) => {
    const shouldSelect = e.target.checked
    const visibleBookingIdSet = new Set(visibleBookingIds)

    setListData((prev) =>
      prev?.map((item) =>
        visibleBookingIdSet.has(item.BookingID) ? { ...item, checked: shouldSelect } : item
      ) || []
    )
    setFiltered((prev) =>
      prev?.map((item) =>
        visibleBookingIdSet.has(item.BookingID) ? { ...item, checked: shouldSelect } : item
      ) || []
    )

    if (shouldSelect) {
      const mergedSelection = [...(selelectedData || [])]
      visibleTableRows.forEach((item) => {
        if (!mergedSelection.some((selectedItem) => selectedItem.BookingID === item.BookingID)) {
          mergedSelection.push({ ...item, checked: true })
        }
      })
      setSelectedData(mergedSelection)
      return
    }

    setSelectedData((selelectedData || []).filter((item) => !visibleBookingIdSet.has(item.BookingID)))
  }

  return (
    <>
      <Stack sx={{ maxHeight: 360, minHeight: 360, minWidth: 650, margin: 2, marginRight: 3, marginLeft: 3 }}>
        <TableContainer className="lr-popup-table lrModel" component={Paper}>
          <Table style={{}} className="table1 tableV2-branch" size="small" aria-label="a dense table" id="showlisttable">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
              <TableRow style={{ background: '#d9edff' }}>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 25px', fontWeight: 'bold' }}>Select</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>LR/Way Bill No.</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Manual LR</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Booking Date</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Consign Type</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Payment Type</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 40px', fontWeight: 'bold', paddingLeft: '20px' }}>
                  Units
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Sender</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Receiver</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>From City</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>To City</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '32px' }}>
                  Amount
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '30px' }}>
                  Activity
                </TableCell>
                {/* <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}></TableCell> */}
              </TableRow>
              <TableRow>
                <TableCell className="checkbox-ctrl">
                  {showSelectAllCheckbox ? (
                    <div className="filter-input" style={{ justifyContent: 'center' }}>
                      <input
                        ref={selectAllRef}
                        type="checkbox"
                        checked={areAllVisibleSelected}
                        disabled={inputCheck}
                        onChange={handleToggleVisibleRows}
                      />
                    </div>
                  ) : null}
                </TableCell>
                {repeatdata.map((item, i) => (
                  <>
                    <TableCell key={i}>
                      <div className={`filter-input ${i == 11 ? 'last-filter' : null}`}>
                        {/* <span className="field">{item.name}</span> */}
                        <input
                          className="field"
                          name="searchInput"
                          placeholder={item.name}
                          onChange={() => {
                            handleChangeContain(item.id, item.colName)
                          }}
                          style={{ width: '75px' }}
                        />
                        <FilterAltIcon />
                      </div>
                    </TableCell>
                  </>
                ))}
                {/* <TableCell></TableCell> */}
              </TableRow>
            </TableHead>
            {TableListData === 'Empty' ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : TableListData === 'DataLoaded' ? (
              <TableBody className="filter-data-row">
                {/* {(rowsPerPage > 0 ? listData?.Table?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : listData?.Table)?.map( */}
                {(rowsPerPage > 0
                  ? (searchStatus ? filtered : ListData)?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : searchStatus
                    ? filtered
                    : ListData
                )?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
            <TableFooter>
              <TableRow>
                <TableCell colSpan={5} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                <TableCell style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right', paddingRight: '7px' }}>Total</TableCell>
                <TableCell style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '63px' }}>
                  {Total === undefined ? '' : Number(Total).toLocaleString('en-IN')}
                </TableCell>
                <TableCell colSpan={3} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                <TableCell colSpan={2} style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '30px' }}>
                  {TotalAmount === undefined ? '' : Number(TotalAmount).toLocaleString('en-IN')}
                </TableCell>
                <TableCell colSpan={2}></TableCell>
              </TableRow>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  // colSpan={3}
                  count={listData?.Table?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  className="test123"
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page',
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                // className="table-pagination-bottom"
                />
              </TableRow>
              {/* <TableCell colSpan={2}> */}
              {/* </TableCell> */}
            </TableFooter>
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getUpdateSHowListData,
  updateDestCity,
  updateDestBrnch,
  updateAlert,
}
export default connect(mapStateToProps, mapDispatchToProps)(MiddleSection)
